"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTrainingSize = exports.isDiaperSize = exports.getBundleStore = exports.SHIP_FREQ_UNIT = exports.SHIP_FREQ_WEEKS = exports.MIN_FREEBIE_ADDONS = exports.SUPPORTED_COUNTRY_CODES = void 0;
var regions_unavailable_1 = require("@launchedla/hb-shared/dist/regions-unavailable");
var currency_js_1 = __importDefault(require("currency.js"));
var date_fns_1 = require("date-fns");
var date_fns_tz_1 = require("date-fns-tz");
var zustand_1 = require("zustand");
var recharge_bundles_1 = require("../../../misc/recharge-bundles");
var ts_utils_1 = require("../../../misc/ts-utils");
var group_variants_for_cart_add_1 = __importDefault(require("../../bundler/group-variants-for-cart-add"));
var calculations_1 = require("../utils/calculations");
exports.SUPPORTED_COUNTRY_CODES = {
    us: 'US',
    ca: 'CA',
};
var FUTURE_INVENTORY_DAYS_AHEAD = 3;
var FUTURE_INVENTORY_TIMEZONE = 'America/Los_Angeles';
var FUTURE_INVENTORY_FORMAT = 'yyyy-MM-dd';
var FUTURE_INVENTORY_MIN_QUANTITY_PATTERNS = 1;
var FUTURE_INVENTORY_MIN_QUANTITY_DISCOUNT_ADDONS = 1;
var FUTURE_INVENTORY_MIN_QUANTITY_FREEBIE_ADDONS = 1;
exports.MIN_FREEBIE_ADDONS = 1;
exports.SHIP_FREQ_WEEKS = 5;
exports.SHIP_FREQ_UNIT = 'week';
var diaperSizes = ['diaper_n', 'diaper_1', 'diaper_2', 'diaper_3', 'diaper_4', 'diaper_5', 'diaper_6'];
var trainingSizes = ['training_12_24', 'training_2t_3t', 'training_3t_4t', 'training_4t_5t'];
var getPatternConfigMap = function (bundleConfig) {
    return {
        diaper_n: bundleConfig.hbus_diaperBundlePatterns_N,
        diaper_1: bundleConfig.hbus_diaperBundlePatterns_1,
        diaper_2: bundleConfig.hbus_diaperBundlePatterns_2,
        diaper_3: bundleConfig.hbus_diaperBundlePatterns_3,
        diaper_4: bundleConfig.hbus_diaperBundlePatterns_4,
        diaper_5: bundleConfig.hbus_diaperBundlePatterns_5,
        diaper_6: bundleConfig.hbus_diaperBundlePatterns_6,
        training_12_24: bundleConfig.hbus_diaperBundlePatterns_12_24M,
        training_2t_3t: bundleConfig.hbus_diaperBundlePatterns_2T_3T,
        training_3t_4t: bundleConfig.hbus_diaperBundlePatterns_3T_4T,
        training_4t_5t: bundleConfig.hbus_diaperBundlePatterns_4T_5T,
        mixed_12_24: bundleConfig.hbus_diaperBundlePatternsMixed_12_24M,
        mixed_2t_3t: bundleConfig.hbus_diaperBundlePatternsMixed_2T_3T,
        mixed_3t_4t: bundleConfig.hbus_diaperBundlePatternsMixed_3T_4T,
        mixed_4t_5t: bundleConfig.hbus_diaperBundlePatternsMixed_4T_5T,
    };
};
/**
 * This store aims to provide the following guarantee: there can never be an invalid bundle stored within its properties. There can be an incomplete bundle, but never an invalid one.
 * This means that, for example, if the main variant stored here is the Training Pants Bundle product, there can be no Diaper Bundle patterns in the patterns property.
 * However, it is possible to store a bundle that is incomplete, like when the user just hasn't finished choosing their bundle options yet.
 * The store exposes an isComplete property that lets the UI know whether or not the bundle can be added to the cart.
 */
var bundleStoreInitializer = function (set, get) { return ({
    selectedMainVariant: undefined,
    selectedPatterns: [],
    selectedDiscountAddons: [],
    selectedFreebieAddons: [],
    selectedAutoAddons: [],
    wantsWipes: true,
    /** Sizes determine the main variant, so here we infer the new main variant and perform necessary actions to keep the bundle valid */
    changeSelectedSizes: function (sizes, wantsWipes) {
        var e_1, _a, e_2, _b, e_3, _c, e_4, _d, e_5, _e, e_6, _f;
        var _g = get(), diaperBundleVariants = _g.diaperBundleVariants, trainingPantsBundleVariants = _g.trainingPantsBundleVariants, mixedBundleVariants = _g.mixedBundleVariants, bundleConfig = _g.bundleConfig, diaperMap = _g.diaperMap, trainingMap = _g.trainingMap, otherMap = _g.otherMap, wipesVariant = _g.wipesVariant, selectedPatterns = _g.selectedPatterns, patternsForExistingCustomersOnly = _g.patternsForExistingCustomersOnly, possibleChoicePatterns = _g.possibleChoicePatterns;
        // when we first load in, it's possible that we haven't initialized these values yet, but the UI should have prevented trying to change sizes
        // until the store is initialized, so we throw an error here
        if (!diaperBundleVariants || !trainingPantsBundleVariants || !mixedBundleVariants || !bundleConfig || !patternsForExistingCustomersOnly || !possibleChoicePatterns) {
            throw new Error('Store not initialized');
        }
        // valid bundles contain: one size of diapers, one size of training pants, two sizes of diapers, two sizes of training pants, or one size of each
        var MAX_SIZES = 2;
        // invalid number of sizes provided; don't change anything; we do expect to hit this regularly when a user tries to select three sizes
        if (sizes.length > MAX_SIZES)
            return;
        var dSizes = sizes.filter(isDiaperSize);
        var tSizes = sizes.filter(isTrainingSize);
        var mainIdentifier = (function () {
            if (dSizes.length > 0 && tSizes.length > 0) {
                // it's a mixed selection (diapers and training pants)
                return 'diaper_and_training';
            }
            else if (dSizes.length > 0) {
                // it's a diaper selection
                if (dSizes.length > 1) {
                    // two sizes are selected
                    return 'diaper_and_diaper';
                }
                else {
                    // one size is selected
                    return dSizes[0];
                }
            }
            else if (tSizes.length > 0) {
                // it's a training pant selection
                if (tSizes.length > 1) {
                    // two sizes are selected
                    return 'training_and_training';
                }
                else {
                    // one size is selected
                    return tSizes[0];
                }
            }
        })();
        // build pattern groups
        var patternConfigMap = getPatternConfigMap(bundleConfig);
        // TODO: type this as a record with the same keys as in selectedSizes?
        var patternGroupsPerSize = {};
        if (mainIdentifier !== 'diaper_and_training') {
            try {
                for (var sizes_1 = __values(sizes), sizes_1_1 = sizes_1.next(); !sizes_1_1.done; sizes_1_1 = sizes_1.next()) {
                    var size = sizes_1_1.value;
                    patternGroupsPerSize[size] = patternConfigMap[size];
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (sizes_1_1 && !sizes_1_1.done && (_a = sizes_1.return)) _a.call(sizes_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        else {
            // we have to make available only mixed patterns if we have a mixed bundle because these patterns each cost
            // the $1 extra we have to charge for each training pants pack in a mixed bundle
            // we know we can only have one of each, so we just use the first of each
            var dSize = dSizes[0];
            var tSize_1 = tSizes[0];
            patternGroupsPerSize[dSize] = patternConfigMap[dSize];
            var trainingGroup = (function () {
                switch (tSize_1) {
                    case 'training_12_24':
                        return patternConfigMap['mixed_12_24'];
                    case 'training_2t_3t':
                        return patternConfigMap['mixed_2t_3t'];
                    case 'training_3t_4t':
                        return patternConfigMap['mixed_3t_4t'];
                    case 'training_4t_5t':
                        return patternConfigMap['mixed_4t_5t'];
                }
            })();
            patternGroupsPerSize[tSize_1] = trainingGroup;
        }
        // build a new map that excludes patterns which don't meet a set of constraints
        var futureDate = (0, date_fns_1.addDays)(new Date(), FUTURE_INVENTORY_DAYS_AHEAD);
        var formattedDay = (0, date_fns_tz_1.formatInTimeZone)(futureDate, FUTURE_INVENTORY_TIMEZONE, FUTURE_INVENTORY_FORMAT);
        var filteredPatternGroupsPerSize = [];
        try {
            for (var _h = __values((0, ts_utils_1.entries)(patternGroupsPerSize)), _j = _h.next(); !_j.done; _j = _h.next()) {
                var _k = __read(_j.value, 2), size = _k[0], groupsForSize = _k[1];
                if (!groupsForSize)
                    throw new Error('Coding bug');
                var filteredPatternGroups = [];
                try {
                    for (var groupsForSize_1 = (e_3 = void 0, __values(groupsForSize)), groupsForSize_1_1 = groupsForSize_1.next(); !groupsForSize_1_1.done; groupsForSize_1_1 = groupsForSize_1.next()) {
                        var group = groupsForSize_1_1.value;
                        var items = [];
                        var _loop_1 = function (variant) {
                            // the constraints
                            // we only check future inventory and ignore current inventory because the merchandising data we receive omits unavailable variants
                            var futureQuantity = variant.futureQuantities._shopify[formattedDay];
                            var hasSufficientFutureInventory = futureQuantity !== undefined && futureQuantity >= FUTURE_INVENTORY_MIN_QUANTITY_PATTERNS;
                            if (!hasSufficientFutureInventory)
                                return "continue";
                            var isPossibleChoice = possibleChoicePatterns.some(function (pattern) { return pattern.variants.some(function (patternVariant) { return patternVariant.id === variant.id; }); });
                            if (!isPossibleChoice)
                                return "continue";
                            var isForExistingBundlersOnly = patternsForExistingCustomersOnly.some(function (pattern) { return pattern.variants.some(function (patternVariant) { return patternVariant.id === variant.id; }); });
                            if (isForExistingBundlersOnly)
                                return "continue";
                            items.push(variant);
                        };
                        try {
                            for (var _l = (e_4 = void 0, __values(group.variants)), _m = _l.next(); !_m.done; _m = _l.next()) {
                                var variant = _m.value;
                                _loop_1(variant);
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                        if (items.length > 0)
                            filteredPatternGroups.push({ variants: items, displayName: group.displayName, displayType: group.displayType });
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (groupsForSize_1_1 && !groupsForSize_1_1.done && (_c = groupsForSize_1.return)) _c.call(groupsForSize_1);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                filteredPatternGroupsPerSize.push({ size: size, groups: filteredPatternGroups });
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
            }
            finally { if (e_2) throw e_2.error; }
        }
        var allValidPatternVariantIds = [];
        try {
            for (var filteredPatternGroupsPerSize_1 = __values(filteredPatternGroupsPerSize), filteredPatternGroupsPerSize_1_1 = filteredPatternGroupsPerSize_1.next(); !filteredPatternGroupsPerSize_1_1.done; filteredPatternGroupsPerSize_1_1 = filteredPatternGroupsPerSize_1.next()) {
                var groupSet = filteredPatternGroupsPerSize_1_1.value;
                try {
                    for (var _o = (e_6 = void 0, __values(groupSet.groups)), _p = _o.next(); !_p.done; _p = _o.next()) {
                        var group = _p.value;
                        var groupVariantIds = group.variants.map(function (variant) { return variant.id; });
                        allValidPatternVariantIds.push.apply(allValidPatternVariantIds, __spreadArray([], __read(groupVariantIds), false));
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (_p && !_p.done && (_f = _o.return)) _f.call(_o);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (filteredPatternGroupsPerSize_1_1 && !filteredPatternGroupsPerSize_1_1.done && (_e = filteredPatternGroupsPerSize_1.return)) _e.call(filteredPatternGroupsPerSize_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
        var validPatternQuantity = (function () {
            // is it a diapers and training pants selection
            if (dSizes.length > 0 && tSizes.length > 0)
                return 7;
            // is it a diaper selection, one or two sizes
            if (dSizes.length > 0)
                return 7;
            // it's a training pant selection, one or two sizes
            return 6;
        })();
        var variantIdMap = __assign(__assign(__assign({}, diaperMap), trainingMap), otherMap);
        var mainVariantMapped = mainIdentifier ? variantIdMap[mainIdentifier] : undefined;
        var mainVariantId = wantsWipes ? mainVariantMapped === null || mainVariantMapped === void 0 ? void 0 : mainVariantMapped.withWipes : mainVariantMapped === null || mainVariantMapped === void 0 ? void 0 : mainVariantMapped.withoutWipes;
        var allVariants = __spreadArray(__spreadArray(__spreadArray([], __read(diaperBundleVariants), false), __read(trainingPantsBundleVariants), false), __read(mixedBundleVariants), false);
        var mainVariant = allVariants.find(function (variant) { return variant.id === mainVariantId; });
        var autoAddons = [];
        if (mainVariant) {
            if (!wipesVariant)
                throw new Error('wipesVariant is not set');
            // is our selected main variant a wipesful bundle?
            var wipesMatches = mainVariant.option2.match(/(\d+) wipes/i);
            var wipesQuantity = wipesMatches ? wipesMatches[1] : 0;
            if (wipesQuantity > 0) {
                autoAddons.push({
                    variant: { id: wipesVariant.id, price: "".concat(wipesVariant.price), compareAtPrice: "".concat(wipesVariant.compare_at_price), option1: wipesVariant.option1 },
                    quantity: Number(wipesQuantity),
                    product: { id: wipesVariant.product_id },
                });
            }
        }
        // remove the patterns that aren't compatible with this new main variant
        var newSelectedPatterns = selectedPatterns.filter(function (pattern) { return allValidPatternVariantIds.includes(pattern.variant.id); });
        // overwrite all validPatternGroups
        set({
            validPatternGroups: filteredPatternGroupsPerSize,
            selectedPatterns: newSelectedPatterns,
            selectedMainVariant: mainVariant,
            selectedAutoAddons: autoAddons,
            validPatternQuantity: validPatternQuantity,
            wantsWipes: wantsWipes,
        });
    },
    changeWantsWipes: function (wantsWipes) {
        var _a = get(), validPatternGroups = _a.validPatternGroups, changeSelectedSizes = _a.changeSelectedSizes;
        var selectedSizes = validPatternGroups.map(function (group) { return group.size; });
        changeSelectedSizes(selectedSizes, wantsWipes);
    },
    /** Check that we don't have invalid or too many patterns, then set selectedPatterns */
    changeSelectedPatterns: function (patterns) {
        var e_7, _a, e_8, _b, e_9, _c, e_10, _d, e_11, _e;
        try {
            // Check for a pattern with a quantity < 1 and error out if found. The caller should not have provided a pattern with quantity < 1
            // and instead should have omitted that pattern from the patterns argument.
            for (var patterns_1 = __values(patterns), patterns_1_1 = patterns_1.next(); !patterns_1_1.done; patterns_1_1 = patterns_1.next()) {
                var pattern = patterns_1_1.value;
                if (pattern.quantity < 1)
                    throw new Error('Invalid patterns');
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (patterns_1_1 && !patterns_1_1.done && (_a = patterns_1.return)) _a.call(patterns_1);
            }
            finally { if (e_7) throw e_7.error; }
        }
        var foundPatternVariantIds = new Set();
        try {
            for (var patterns_2 = __values(patterns), patterns_2_1 = patterns_2.next(); !patterns_2_1.done; patterns_2_1 = patterns_2.next()) {
                var pattern = patterns_2_1.value;
                if (foundPatternVariantIds.has(pattern.variant.id))
                    throw new Error('Found two of the same pattern (quantity should have been increased for one instead of adding another)');
                foundPatternVariantIds.add(pattern.variant.id);
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (patterns_2_1 && !patterns_2_1.done && (_b = patterns_2.return)) _b.call(patterns_2);
            }
            finally { if (e_8) throw e_8.error; }
        }
        var _f = get(), validPatternGroups = _f.validPatternGroups, validPatternQuantity = _f.validPatternQuantity, bundleConfig = _f.bundleConfig;
        var allValidPatternVariantIds = [];
        try {
            for (var _g = __values(validPatternGroups.map(function (group) { return group.groups; })), _h = _g.next(); !_h.done; _h = _g.next()) {
                var groupSet = _h.value;
                try {
                    for (var groupSet_1 = (e_10 = void 0, __values(groupSet)), groupSet_1_1 = groupSet_1.next(); !groupSet_1_1.done; groupSet_1_1 = groupSet_1.next()) {
                        var group = groupSet_1_1.value;
                        var groupVariantIds = group.variants.map(function (variant) { return variant.id; });
                        allValidPatternVariantIds.push.apply(allValidPatternVariantIds, __spreadArray([], __read(groupVariantIds), false));
                    }
                }
                catch (e_10_1) { e_10 = { error: e_10_1 }; }
                finally {
                    try {
                        if (groupSet_1_1 && !groupSet_1_1.done && (_d = groupSet_1.return)) _d.call(groupSet_1);
                    }
                    finally { if (e_10) throw e_10.error; }
                }
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (_h && !_h.done && (_c = _g.return)) _c.call(_g);
            }
            finally { if (e_9) throw e_9.error; }
        }
        // invalid pattern provided; caller should first call changeSizes to alter the valid pattern groups and then try to make this change
        // TODO: think about whether we should provide a different API to deal with this
        if (patterns.some(function (pattern) { return !allValidPatternVariantIds.includes(pattern.variant.id); }))
            return;
        // Were too many patterns provided? Note that we don't check here if too few patterns were provided;
        // that would mean that the bundle is just not yet complete.
        var totalNumPatterns = patterns.reduce(function (total, pattern) { return total + pattern.quantity; }, 0);
        if (totalNumPatterns > validPatternQuantity)
            return;
        // for each pattern, figure out the size by looking in the bundleConfig object and seeing which size contains the variant id we're looking for
        if (!bundleConfig)
            throw new Error('bundleConfig is not set');
        var patternConfigMap = getPatternConfigMap(bundleConfig);
        var selectedPatterns = [];
        var _loop_2 = function (pattern) {
            var size = (function () {
                var e_12, _a, e_13, _b, e_14, _c;
                try {
                    for (var _d = (e_12 = void 0, __values((0, ts_utils_1.entries)(patternConfigMap))), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var _f = __read(_e.value, 2), s = _f[0], groups = _f[1];
                        try {
                            for (var groups_1 = (e_13 = void 0, __values(groups)), groups_1_1 = groups_1.next(); !groups_1_1.done; groups_1_1 = groups_1.next()) {
                                var group = groups_1_1.value;
                                try {
                                    for (var _g = (e_14 = void 0, __values(group.variants)), _h = _g.next(); !_h.done; _h = _g.next()) {
                                        var variant = _h.value;
                                        if (variant.id === pattern.variant.id)
                                            return s;
                                    }
                                }
                                catch (e_14_1) { e_14 = { error: e_14_1 }; }
                                finally {
                                    try {
                                        if (_h && !_h.done && (_c = _g.return)) _c.call(_g);
                                    }
                                    finally { if (e_14) throw e_14.error; }
                                }
                            }
                        }
                        catch (e_13_1) { e_13 = { error: e_13_1 }; }
                        finally {
                            try {
                                if (groups_1_1 && !groups_1_1.done && (_b = groups_1.return)) _b.call(groups_1);
                            }
                            finally { if (e_13) throw e_13.error; }
                        }
                    }
                }
                catch (e_12_1) { e_12 = { error: e_12_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    }
                    finally { if (e_12) throw e_12.error; }
                }
            })();
            if (!size)
                throw new Error("Coding bug in finding which group the pattern belongs to for variant id ".concat(pattern.variant.id));
            selectedPatterns.push({ variant: pattern.variant, quantity: pattern.quantity, size: size });
        };
        try {
            for (var _j = __values(Object.values(patterns)), _k = _j.next(); !_k.done; _k = _j.next()) {
                var pattern = _k.value;
                _loop_2(pattern);
            }
        }
        catch (e_11_1) { e_11 = { error: e_11_1 }; }
        finally {
            try {
                if (_k && !_k.done && (_e = _j.return)) _e.call(_j);
            }
            finally { if (e_11) throw e_11.error; }
        }
        set({ selectedPatterns: selectedPatterns });
    },
    changeSelectedDiscountAddons: function (addons) {
        var e_15, _a, e_16, _b;
        try {
            // Check for an addon with a quantity < 1 and error out if found. The caller should not have provided a pattern with quantity < 1
            // and instead should have omitted that addon from the addons argument.
            for (var addons_1 = __values(addons), addons_1_1 = addons_1.next(); !addons_1_1.done; addons_1_1 = addons_1.next()) {
                var addon = addons_1_1.value;
                if (addon.quantity < 1)
                    throw new Error('Invalid discount addon quantity');
            }
        }
        catch (e_15_1) { e_15 = { error: e_15_1 }; }
        finally {
            try {
                if (addons_1_1 && !addons_1_1.done && (_a = addons_1.return)) _a.call(addons_1);
            }
            finally { if (e_15) throw e_15.error; }
        }
        var foundAddonVariantIds = new Set();
        try {
            for (var addons_2 = __values(addons), addons_2_1 = addons_2.next(); !addons_2_1.done; addons_2_1 = addons_2.next()) {
                var addon = addons_2_1.value;
                if (foundAddonVariantIds.has(addon.variant.id))
                    throw new Error('Found two of the same discount addon (quantity should have been increased for one instead of adding another)');
                foundAddonVariantIds.add(addon.variant.id);
            }
        }
        catch (e_16_1) { e_16 = { error: e_16_1 }; }
        finally {
            try {
                if (addons_2_1 && !addons_2_1.done && (_b = addons_2.return)) _b.call(addons_2);
            }
            finally { if (e_16) throw e_16.error; }
        }
        // were too many total discount addons provided?
        var MAX_DISCOUNT_ADDONS = 5;
        var selectedAddonQuantity = addons.reduce(function (total, pattern) { return total + pattern.quantity; }, 0);
        if (selectedAddonQuantity > MAX_DISCOUNT_ADDONS)
            return;
        set({ selectedDiscountAddons: addons });
    },
    changeSelectedFreebieAddons: function (addons) {
        var e_17, _a, e_18, _b;
        try {
            // Check for an addon with a quantity < 1 and error out if found. The caller should not have provided a pattern with quantity < 1
            // and instead should have omitted that addon from the addons argument.
            for (var addons_3 = __values(addons), addons_3_1 = addons_3.next(); !addons_3_1.done; addons_3_1 = addons_3.next()) {
                var addon = addons_3_1.value;
                if (addon.quantity < 1)
                    throw new Error('Invalid freebie addon quantity');
            }
        }
        catch (e_17_1) { e_17 = { error: e_17_1 }; }
        finally {
            try {
                if (addons_3_1 && !addons_3_1.done && (_a = addons_3.return)) _a.call(addons_3);
            }
            finally { if (e_17) throw e_17.error; }
        }
        var foundAddonVariantIds = new Set();
        try {
            for (var addons_4 = __values(addons), addons_4_1 = addons_4.next(); !addons_4_1.done; addons_4_1 = addons_4.next()) {
                var addon = addons_4_1.value;
                if (foundAddonVariantIds.has(addon.variant.id))
                    throw new Error('Found two of the same freebie addon (quantity should have been increased for one instead of adding another)');
                foundAddonVariantIds.add(addon.variant.id);
            }
        }
        catch (e_18_1) { e_18 = { error: e_18_1 }; }
        finally {
            try {
                if (addons_4_1 && !addons_4_1.done && (_b = addons_4.return)) _b.call(addons_4);
            }
            finally { if (e_18) throw e_18.error; }
        }
        // were too many total discount addons provided?
        var MAX_FREEBIE_ADDONS = 1;
        var selectedAddonQuantity = addons.reduce(function (total, pattern) { return total + pattern.quantity; }, 0);
        if (selectedAddonQuantity > MAX_FREEBIE_ADDONS)
            return;
        set({ selectedFreebieAddons: addons });
    },
    diaperBundleVariants: undefined,
    diaperMap: undefined,
    trainingMap: undefined,
    otherMap: undefined,
    trainingPantsBundleVariants: undefined,
    mixedBundleVariants: undefined,
    wipesVariant: undefined,
    bundleConfig: undefined,
    products: undefined,
    mainBundleProduct: undefined,
    cdnBundleSettings: undefined,
    rechargeBundlesEnabled: false,
    patternsForExistingCustomersOnly: undefined,
    productsUnavailableInUserRegion: undefined,
    possibleChoicePatterns: undefined,
    diaperSizeRationale: undefined,
    trainingPantSizeRationale: undefined,
    validPatternGroups: [],
    validPatternQuantity: 0,
    preferredPatternGender: undefined,
    patternStepHeader: undefined,
    sizeStepHeader: undefined,
    /** Get available freebie addons, merchandised into groups and filtered by future inventory availability */
    buildAvailableFreebieAddonGroups: function () {
        var e_19, _a, e_20, _b;
        var _c = get(), bundleConfig = _c.bundleConfig, productsUnavailableInUserRegion = _c.productsUnavailableInUserRegion;
        if (!bundleConfig || !productsUnavailableInUserRegion)
            return;
        var futureDate = (0, date_fns_1.addDays)(new Date(), FUTURE_INVENTORY_DAYS_AHEAD);
        var formattedDay = (0, date_fns_tz_1.formatInTimeZone)(futureDate, FUTURE_INVENTORY_TIMEZONE, FUTURE_INVENTORY_FORMAT);
        var groups = [];
        try {
            for (var _d = __values(bundleConfig.hbus_diaperBundleFreebieProducts), _e = _d.next(); !_e.done; _e = _d.next()) {
                var config = _e.value;
                var items = [];
                var _loop_3 = function (product) {
                    var variant = product.variants.find(function (v) { return v.sku === product.selectedSku; });
                    var isAvailableInUserRegion = !productsUnavailableInUserRegion.some(function (p) { return p.id === product.id; });
                    if (variant && isAvailableInUserRegion) {
                        var futureQuantity = variant.futureQuantities._shopify[formattedDay];
                        // we only check future inventory and ignore current inventory because the merchandising data we receive omits unavailable (selectedSku) variants
                        if (futureQuantity !== undefined && futureQuantity >= FUTURE_INVENTORY_MIN_QUANTITY_FREEBIE_ADDONS)
                            items.push({ product: product, variant: variant });
                    }
                };
                try {
                    for (var _f = (e_20 = void 0, __values(config.products)), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var product = _g.value;
                        _loop_3(product);
                    }
                }
                catch (e_20_1) { e_20 = { error: e_20_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_20) throw e_20.error; }
                }
                if (items.length > 0)
                    groups.push({ items: items, displayName: config.displayName, displayType: config.displayType });
            }
        }
        catch (e_19_1) { e_19 = { error: e_19_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_19) throw e_19.error; }
        }
        return groups;
    },
    /** Get available discount addons, merchandised into groups and filtered by future inventory availability */
    buildAvailableDiscountAddonGroups: function () {
        var e_21, _a, e_22, _b;
        var _c = get(), bundleConfig = _c.bundleConfig, productsUnavailableInUserRegion = _c.productsUnavailableInUserRegion;
        if (!bundleConfig || !productsUnavailableInUserRegion)
            return;
        var futureDate = (0, date_fns_1.addDays)(new Date(), FUTURE_INVENTORY_DAYS_AHEAD);
        var formattedDay = (0, date_fns_tz_1.formatInTimeZone)(futureDate, FUTURE_INVENTORY_TIMEZONE, FUTURE_INVENTORY_FORMAT);
        var groups = [];
        try {
            for (var _d = __values(bundleConfig.hbus_diaperBundleAddOnProducts), _e = _d.next(); !_e.done; _e = _d.next()) {
                var config = _e.value;
                var items = [];
                var _loop_4 = function (product) {
                    var variant = product.variants.find(function (v) { return v.sku === product.selectedSku; });
                    var isAvailableInUserRegion = !productsUnavailableInUserRegion.some(function (p) { return p.id === product.id; });
                    if (variant && isAvailableInUserRegion) {
                        var futureQuantity = variant.futureQuantities._shopify[formattedDay];
                        // we only check future inventory and ignore current inventory because the merchandising data we receive omits unavailable (selectedSku) variants
                        if (futureQuantity !== undefined && futureQuantity >= FUTURE_INVENTORY_MIN_QUANTITY_DISCOUNT_ADDONS)
                            items.push({ product: product, variant: variant });
                    }
                };
                try {
                    for (var _f = (e_22 = void 0, __values(config.products)), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var product = _g.value;
                        _loop_4(product);
                    }
                }
                catch (e_22_1) { e_22 = { error: e_22_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_22) throw e_22.error; }
                }
                if (items.length > 0)
                    groups.push({ items: items, displayName: config.displayName, displayType: config.displayType });
            }
        }
        catch (e_21_1) { e_21 = { error: e_21_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_21) throw e_21.error; }
        }
        return groups;
    },
    calculateBundleSubtotal: function () {
        var _a = get(), selectedMainVariant = _a.selectedMainVariant, selectedPatterns = _a.selectedPatterns, selectedDiscountAddons = _a.selectedDiscountAddons;
        if (!selectedMainVariant)
            throw new Error('selectedMainVariant is not set');
        return (0, calculations_1.calculateBundleSubtotal)(selectedMainVariant, selectedDiscountAddons, selectedPatterns);
    },
    /** Format our stored bundle in the format understood by the add to cart app */
    buildBundle: function () {
        var e_23, _a, e_24, _b, e_25, _c, e_26, _d, e_27, _e;
        var _f = get(), selectedPatterns = _f.selectedPatterns, selectedMainVariant = _f.selectedMainVariant, selectedDiscountAddons = _f.selectedDiscountAddons, selectedFreebieAddons = _f.selectedFreebieAddons, selectedAutoAddons = _f.selectedAutoAddons, mainBundleProduct = _f.mainBundleProduct, isComplete = _f.isComplete, rechargeBundlesEnabled = _f.rechargeBundlesEnabled, cdnBundleSettings = _f.cdnBundleSettings;
        // check for bundle completion before giving the UI something to add to the cart
        if (!isComplete())
            return;
        // "expand" patterns and addons by duplicating each variant `quantity` times
        var expandedPatterns = [];
        try {
            for (var selectedPatterns_1 = __values(selectedPatterns), selectedPatterns_1_1 = selectedPatterns_1.next(); !selectedPatterns_1_1.done; selectedPatterns_1_1 = selectedPatterns_1.next()) {
                var pattern = selectedPatterns_1_1.value;
                for (var i = 0; i < pattern.quantity; i++) {
                    expandedPatterns.push(pattern.variant);
                }
            }
        }
        catch (e_23_1) { e_23 = { error: e_23_1 }; }
        finally {
            try {
                if (selectedPatterns_1_1 && !selectedPatterns_1_1.done && (_a = selectedPatterns_1.return)) _a.call(selectedPatterns_1);
            }
            finally { if (e_23) throw e_23.error; }
        }
        var expandedDiscountAddons = [];
        try {
            for (var selectedDiscountAddons_1 = __values(selectedDiscountAddons), selectedDiscountAddons_1_1 = selectedDiscountAddons_1.next(); !selectedDiscountAddons_1_1.done; selectedDiscountAddons_1_1 = selectedDiscountAddons_1.next()) {
                var addon = selectedDiscountAddons_1_1.value;
                for (var i = 0; i < addon.quantity; i++) {
                    expandedDiscountAddons.push(__assign(__assign({}, addon.variant), { product_id: addon.product.id }));
                }
            }
        }
        catch (e_24_1) { e_24 = { error: e_24_1 }; }
        finally {
            try {
                if (selectedDiscountAddons_1_1 && !selectedDiscountAddons_1_1.done && (_b = selectedDiscountAddons_1.return)) _b.call(selectedDiscountAddons_1);
            }
            finally { if (e_24) throw e_24.error; }
        }
        var expandedFreebieAddons = [];
        try {
            for (var selectedFreebieAddons_1 = __values(selectedFreebieAddons), selectedFreebieAddons_1_1 = selectedFreebieAddons_1.next(); !selectedFreebieAddons_1_1.done; selectedFreebieAddons_1_1 = selectedFreebieAddons_1.next()) {
                var addon = selectedFreebieAddons_1_1.value;
                for (var i = 0; i < addon.quantity; i++) {
                    expandedFreebieAddons.push(__assign(__assign({}, addon.variant), { product_id: addon.product.id }));
                }
            }
        }
        catch (e_25_1) { e_25 = { error: e_25_1 }; }
        finally {
            try {
                if (selectedFreebieAddons_1_1 && !selectedFreebieAddons_1_1.done && (_c = selectedFreebieAddons_1.return)) _c.call(selectedFreebieAddons_1);
            }
            finally { if (e_25) throw e_25.error; }
        }
        var expandedAutoAddons = [];
        try {
            for (var selectedAutoAddons_1 = __values(selectedAutoAddons), selectedAutoAddons_1_1 = selectedAutoAddons_1.next(); !selectedAutoAddons_1_1.done; selectedAutoAddons_1_1 = selectedAutoAddons_1.next()) {
                var addon = selectedAutoAddons_1_1.value;
                for (var i = 0; i < addon.quantity; i++) {
                    expandedAutoAddons.push(__assign(__assign({}, addon.variant), { product_id: addon.product.id }));
                }
            }
        }
        catch (e_26_1) { e_26 = { error: e_26_1 }; }
        finally {
            try {
                if (selectedAutoAddons_1_1 && !selectedAutoAddons_1_1.done && (_d = selectedAutoAddons_1.return)) _d.call(selectedAutoAddons_1);
            }
            finally { if (e_26) throw e_26.error; }
        }
        var discountAddonOrigTotal = expandedDiscountAddons.map(function (variant) { return Number(variant.compareAtPrice); }).reduce(function (acc, prc) { return acc + prc; }, 0);
        var freebieAddonOrigTotal = expandedFreebieAddons.map(function (variant) { return Number(variant.compareAtPrice); }).reduce(function (acc, prc) { return acc + prc; }, 0);
        if (!selectedMainVariant)
            throw new Error('selectedMainVariant is not set');
        if (!mainBundleProduct)
            throw new Error('mainBundleProduct is not set');
        // diaper bundler v1 submits just this property in cents rather than dollars, so we mimic that here
        var compareAtPriceCents = (0, currency_js_1.default)(Number(selectedMainVariant.compare_at_price || selectedMainVariant.price)).multiply(100).value;
        var subscriptionProperties = (function () {
            var properties = {};
            // we include these properties even on recharge bundles because they are used by our cart, not by recharge
            properties.original_bundle_value = freebieAddonOrigTotal + discountAddonOrigTotal + Number(selectedMainVariant.price);
            properties.compare_at_price = compareAtPriceCents;
            if (!rechargeBundlesEnabled) {
                properties.charge_interval_frequency = "".concat(exports.SHIP_FREQ_WEEKS); // diaper bundler v1 uses a string for this property, so we mimic that here
                properties.shipping_interval_frequency = "".concat(exports.SHIP_FREQ_WEEKS); // diaper bundler v1 uses a string for this property, so we mimic that here
                properties.shipping_interval_unit_type = exports.SHIP_FREQ_UNIT;
                properties.subscription_id = mainBundleProduct.subscriptionId;
            }
            return properties;
        })();
        var bundleId = new Date().getTime().toString();
        // We still add the parent_bundle_id property to recharge bundle children because the cart uses it to visually display the items as a bundle
        var childProperties = __assign({ parent_bundle_id: bundleId }, subscriptionProperties);
        var toShopifyVariant = function (variant, productId) {
            var shopifyVariant = {
                id: variant.id,
                compare_at_price: variant.compareAtPrice || '',
                price: variant.price,
                product_id: productId,
            };
            return shopifyVariant;
        };
        var convertedExpandedPatterns = expandedPatterns.map(function (pattern) { return toShopifyVariant(pattern, pattern.product.id); });
        var convertedExpandedAddons = expandedFreebieAddons.map(function (addon) { return toShopifyVariant(addon, addon.product_id); });
        var convertedExpandedDiscountAddons = expandedDiscountAddons.map(function (addon) { return toShopifyVariant(addon, addon.product_id); });
        var convertedExpandedAutoAddons = expandedAutoAddons.map(function (addon) { return toShopifyVariant(addon, addon.product_id); });
        var choices = __spreadArray(__spreadArray(__spreadArray([
            // First we include our internal main bundle product. Even with recharge bundles, we include our main bundle variant because it's what sets the price of the bundle.
            {
                // We still add the bundle_id id property for recharge bundle main products because the cart uses it to visually display the items as a bundle
                createItemParams: [selectedMainVariant.id, { properties: __assign({ bundle_id: bundleId }, subscriptionProperties) }],
                variant: __assign(__assign({}, selectedMainVariant), { product: { id: selectedMainVariant.product_id } }),
            }
        ], __read((0, group_variants_for_cart_add_1.default)(convertedExpandedPatterns.map(function (choice) { return (__assign(__assign({}, choice), { product: { id: choice.product_id } })); }), childProperties)), false), __read((0, group_variants_for_cart_add_1.default)(convertedExpandedDiscountAddons.map(function (choice) { return (__assign(__assign({}, choice), { product: { id: choice.product_id } })); }), childProperties)), false), __read((0, group_variants_for_cart_add_1.default)(convertedExpandedAutoAddons.map(function (choice) { return (__assign(__assign({}, choice), { product: { id: choice.product_id } })); }), childProperties)), false);
        var nonSubscriptionItems = (0, group_variants_for_cart_add_1.default)(convertedExpandedAddons.map(function (choice) { return (__assign(__assign({}, choice), { product: { id: choice.product_id } })); }), { parent_bundle_id: bundleId });
        var params;
        if (rechargeBundlesEnabled) {
            if (!cdnBundleSettings)
                throw new Error('Recharge bundles enabled but cdnBundleSettings is not set');
            params = (0, recharge_bundles_1.buildDynamicRechargeBundle)({
                choices: choices,
                cdnBundleSettings: cdnBundleSettings,
                mainRcBundleProduct: mainBundleProduct,
                shippingIntervalFrequency: exports.SHIP_FREQ_WEEKS,
                shippingIntervalUnitType: exports.SHIP_FREQ_UNIT,
            });
        }
        else {
            params = choices.map(function (item) { return item.createItemParams; });
        }
        try {
            // TODO: test with a bundle that has two items (two diapers, diapers and training pants)
            // Add non-subscription items after calling buildDynamicRechargeBundle so that they don't end up in the
            // bundle_selection that recharge will create. If this happened, the customer would be subscribed to them.
            for (var nonSubscriptionItems_1 = __values(nonSubscriptionItems), nonSubscriptionItems_1_1 = nonSubscriptionItems_1.next(); !nonSubscriptionItems_1_1.done; nonSubscriptionItems_1_1 = nonSubscriptionItems_1.next()) {
                var item = nonSubscriptionItems_1_1.value;
                params.push(item.createItemParams);
            }
        }
        catch (e_27_1) { e_27 = { error: e_27_1 }; }
        finally {
            try {
                if (nonSubscriptionItems_1_1 && !nonSubscriptionItems_1_1.done && (_e = nonSubscriptionItems_1.return)) _e.call(nonSubscriptionItems_1);
            }
            finally { if (e_27) throw e_27.error; }
        }
        return params;
    },
    /** @returns whether or not the bundle is "complete" (able to be added to the cart) */
    isComplete: function () {
        var e_28, _a;
        var _b = get(), validPatternQuantity = _b.validPatternQuantity, validPatternGroups = _b.validPatternGroups, selectedPatterns = _b.selectedPatterns;
        var patternQuantity = selectedPatterns.reduce(function (total, pattern) { return total + pattern.quantity; }, 0);
        if (patternQuantity !== validPatternQuantity)
            return false;
        // check if any size doesn't have at least one pattern
        var selectedPatternsPerSize = (function () {
            var e_29, _a, e_30, _b, e_31, _c;
            var _d, _e;
            var result = {};
            try {
                for (var validPatternGroups_1 = __values(validPatternGroups), validPatternGroups_1_1 = validPatternGroups_1.next(); !validPatternGroups_1_1.done; validPatternGroups_1_1 = validPatternGroups_1.next()) {
                    var validPatternGroup = validPatternGroups_1_1.value;
                    var categories = validPatternGroup.groups;
                    try {
                        for (var categories_1 = (e_30 = void 0, __values(categories)), categories_1_1 = categories_1.next(); !categories_1_1.done; categories_1_1 = categories_1.next()) {
                            var category = categories_1_1.value;
                            var _loop_5 = function (variant) {
                                var pattern = selectedPatterns.find(function (p) { return p.variant.id === variant.id; });
                                if (pattern) {
                                    var size = validPatternGroup.size;
                                    if (!result[size])
                                        result[size] = [];
                                    var alreadyThere = (_d = result[size]) === null || _d === void 0 ? void 0 : _d.some(function (p) { return p.variant.id === variant.id; });
                                    if (!alreadyThere)
                                        (_e = result[size]) === null || _e === void 0 ? void 0 : _e.push(pattern);
                                }
                            };
                            try {
                                for (var _f = (e_31 = void 0, __values(category.variants)), _g = _f.next(); !_g.done; _g = _f.next()) {
                                    var variant = _g.value;
                                    _loop_5(variant);
                                }
                            }
                            catch (e_31_1) { e_31 = { error: e_31_1 }; }
                            finally {
                                try {
                                    if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
                                }
                                finally { if (e_31) throw e_31.error; }
                            }
                        }
                    }
                    catch (e_30_1) { e_30 = { error: e_30_1 }; }
                    finally {
                        try {
                            if (categories_1_1 && !categories_1_1.done && (_b = categories_1.return)) _b.call(categories_1);
                        }
                        finally { if (e_30) throw e_30.error; }
                    }
                }
            }
            catch (e_29_1) { e_29 = { error: e_29_1 }; }
            finally {
                try {
                    if (validPatternGroups_1_1 && !validPatternGroups_1_1.done && (_a = validPatternGroups_1.return)) _a.call(validPatternGroups_1);
                }
                finally { if (e_29) throw e_29.error; }
            }
            return result;
        })();
        try {
            for (var _c = __values(Object.values(selectedPatternsPerSize)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var patterns = _d.value;
                var quantity = patterns.reduce(function (total, pattern) { return total + pattern.quantity; }, 0);
                if (quantity < 1)
                    return false;
            }
        }
        catch (e_28_1) { e_28 = { error: e_28_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_28) throw e_28.error; }
        }
        return true;
    },
    initialized: false,
    initialize: function (_a) {
        var e_32, _b, e_33, _c;
        var _d;
        var countryCode = _a.countryCode, products = _a.products, bundleConfig = _a.bundleConfig, cdnBundleSettings = _a.cdnBundleSettings, mainBundleProduct = _a.mainBundleProduct, rechargeBundlesEnabled = _a.rechargeBundlesEnabled, wantsWipes = _a.wantsWipes, presetSizes = _a.presetSizes, presetPreferredPatternGender = _a.presetPreferredPatternGender, presetDiaperSizeRationale = _a.presetDiaperSizeRationale, presetTrainingPantSizeRationale = _a.presetTrainingPantSizeRationale, presetPatternStepHeader = _a.presetPatternStepHeader, presetSizeStepHeader = _a.presetSizeStepHeader;
        var _e = get(), initialized = _e.initialized, changeWantsWipes = _e.changeWantsWipes, changeSelectedSizes = _e.changeSelectedSizes;
        if (initialized)
            return;
        // This tag is currently only used for wipes. We should consider renaming it because we have so much logic in the bundler exclusively around wipes,
        // not generically for auto addons (because we don't have any auto addons besides wipes).
        var wipesVariant = (_d = products.find(function (product) { return product.tags.includes('Bundler App Auto Add-On'); })) === null || _d === void 0 ? void 0 : _d.variants[0];
        var mainDiaperBundleProduct = products.find(function (product) { return product.handle === 'diaper-bundle'; });
        var mainTrainingPantsBundleProduct = products.find(function (product) { return product.handle === 'training-pants-bundle'; });
        if (!mainDiaperBundleProduct || !mainTrainingPantsBundleProduct)
            throw new Error('Unable to find main product(s)');
        var diaperBundleVariants = mainDiaperBundleProduct.variants.filter(function (variant) { return variant.option1 !== 'Multi'; });
        var trainingPantsBundleVariants = mainTrainingPantsBundleProduct.variants;
        var mixedBundleVariants = mainDiaperBundleProduct.variants.filter(function (variant) { return variant.option1 === 'Multi'; });
        var possibleChoicePatterns = products.filter(function (product) { return product.tags.includes('Bundler App Possible Choices') || product.tags.includes('Bundler App Possible Nighttime Choices'); });
        var patternsForExistingCustomersOnly = products.filter(function (product) { return product.tags.includes('Bundler App Disallow'); });
        var productsUnavailableInUserRegion = products.filter(function (product) {
            var e_34, _a;
            var unavailableRegions = (0, regions_unavailable_1.getUnavailableRegions)(product.tags.split(', '));
            try {
                for (var unavailableRegions_1 = __values(unavailableRegions), unavailableRegions_1_1 = unavailableRegions_1.next(); !unavailableRegions_1_1.done; unavailableRegions_1_1 = unavailableRegions_1.next()) {
                    var region = unavailableRegions_1_1.value;
                    if (region.countryCode === countryCode && !region.provinceCode)
                        return true;
                }
            }
            catch (e_34_1) { e_34 = { error: e_34_1 }; }
            finally {
                try {
                    if (unavailableRegions_1_1 && !unavailableRegions_1_1.done && (_a = unavailableRegions_1.return)) _a.call(unavailableRegions_1);
                }
                finally { if (e_34) throw e_34.error; }
            }
            return false;
        });
        // map our concept of diaper sizes to Shopify Variants' "option1" values
        var diaperSizeOptionMap = {
            diaper_n: 'N',
            diaper_1: '1',
            diaper_2: '2',
            diaper_3: '3',
            diaper_4: '4',
            diaper_5: '5',
            diaper_6: '6',
        };
        var diaperOptions = ['diaper_n', 'diaper_1', 'diaper_2', 'diaper_3', 'diaper_4', 'diaper_5', 'diaper_6'];
        var diaperMap = {};
        var _loop_6 = function (option) {
            var option1 = diaperSizeOptionMap[option];
            var variantWithWipes = mainDiaperBundleProduct.variants.find(function (variant) { return variant.option1 === option1 && variant.option2.includes('wipes'); });
            var variantWithoutWipes = mainDiaperBundleProduct.variants.find(function (variant) { return variant.option1 === option1 && !variant.option2.includes('wipes'); });
            if (!variantWithWipes)
                throw new Error("Cannot find diaper variant with wipes for option ".concat(option1));
            if (!variantWithoutWipes)
                throw new Error("Cannot find diaper variant without wipes for option ".concat(option1));
            diaperMap[option] = { withWipes: variantWithWipes.id, withoutWipes: variantWithoutWipes.id };
        };
        try {
            for (var diaperOptions_1 = __values(diaperOptions), diaperOptions_1_1 = diaperOptions_1.next(); !diaperOptions_1_1.done; diaperOptions_1_1 = diaperOptions_1.next()) {
                var option = diaperOptions_1_1.value;
                _loop_6(option);
            }
        }
        catch (e_32_1) { e_32 = { error: e_32_1 }; }
        finally {
            try {
                if (diaperOptions_1_1 && !diaperOptions_1_1.done && (_b = diaperOptions_1.return)) _b.call(diaperOptions_1);
            }
            finally { if (e_32) throw e_32.error; }
        }
        // map our concept of training sizes to Shopify Variants' "option1" values
        var trainingSizeOptionMap = {
            training_12_24: '12-24M',
            training_2t_3t: '2T-3T',
            training_3t_4t: '3T-4T',
            training_4t_5t: '4T-5T',
        };
        var trainingOptions = ['training_12_24', 'training_2t_3t', 'training_3t_4t', 'training_4t_5t'];
        var trainingMap = {};
        var _loop_7 = function (option) {
            var option1 = trainingSizeOptionMap[option];
            var variantWithWipes = mainTrainingPantsBundleProduct.variants.find(function (variant) { return variant.option1 === option1 && variant.option2.includes('wipes'); });
            var variantWithoutWipes = mainTrainingPantsBundleProduct.variants.find(function (variant) { return variant.option1 === option1 && !variant.option2.includes('wipes'); });
            if (!variantWithWipes)
                throw new Error("Cannot find training variant with wipes for option ".concat(option1));
            if (!variantWithoutWipes)
                throw new Error("Cannot find training variant without wipes for option ".concat(option1));
            trainingMap[option] = { withWipes: variantWithWipes.id, withoutWipes: variantWithoutWipes.id };
        };
        try {
            for (var trainingOptions_1 = __values(trainingOptions), trainingOptions_1_1 = trainingOptions_1.next(); !trainingOptions_1_1.done; trainingOptions_1_1 = trainingOptions_1.next()) {
                var option = trainingOptions_1_1.value;
                _loop_7(option);
            }
        }
        catch (e_33_1) { e_33 = { error: e_33_1 }; }
        finally {
            try {
                if (trainingOptions_1_1 && !trainingOptions_1_1.done && (_c = trainingOptions_1.return)) _c.call(trainingOptions_1);
            }
            finally { if (e_33) throw e_33.error; }
        }
        var diaperAndDiaperVariantWithWipes = mainDiaperBundleProduct.variants.find(function (variant) { return variant.option1 === 'Multi' && variant.option2.includes('wipes'); });
        var diaperAndDiaperWithoutWipes = mainDiaperBundleProduct.variants.find(function (variant) { return variant.option1 === 'Multi' && !variant.option2.includes('wipes'); });
        var diaperAndTrainingWithWipes = diaperAndDiaperVariantWithWipes;
        var diaperAndTrainingWithoutWipes = diaperAndDiaperWithoutWipes;
        var trainingAndTrainingVariantWithWipes = mainTrainingPantsBundleProduct.variants.find(function (variant) { return variant.option1 === 'Multi' && variant.option2.includes('wipes'); });
        var trainingAndTrainingVariantWithoutWipes = mainTrainingPantsBundleProduct.variants.find(function (variant) { return variant.option1 === 'Multi' && !variant.option2.includes('wipes'); });
        var otherMap = {};
        if (!diaperAndDiaperVariantWithWipes ||
            !diaperAndDiaperWithoutWipes ||
            !diaperAndTrainingWithWipes ||
            !diaperAndTrainingWithoutWipes ||
            !trainingAndTrainingVariantWithWipes ||
            !trainingAndTrainingVariantWithoutWipes) {
            throw new Error('Cannot find other variant');
        }
        otherMap.diaper_and_diaper = { withWipes: diaperAndDiaperVariantWithWipes.id, withoutWipes: diaperAndDiaperWithoutWipes.id };
        otherMap.diaper_and_training = { withWipes: diaperAndTrainingWithWipes.id, withoutWipes: diaperAndTrainingWithoutWipes.id };
        otherMap.training_and_training = { withWipes: trainingAndTrainingVariantWithWipes.id, withoutWipes: trainingAndTrainingVariantWithoutWipes.id };
        set({
            products: products,
            diaperMap: diaperMap,
            trainingMap: trainingMap,
            otherMap: otherMap,
            mixedBundleVariants: mixedBundleVariants,
            diaperBundleVariants: diaperBundleVariants,
            trainingPantsBundleVariants: trainingPantsBundleVariants,
            wipesVariant: wipesVariant,
            cdnBundleSettings: cdnBundleSettings,
            mainBundleProduct: mainBundleProduct,
            rechargeBundlesEnabled: rechargeBundlesEnabled,
            possibleChoicePatterns: possibleChoicePatterns,
            patternsForExistingCustomersOnly: patternsForExistingCustomersOnly,
            productsUnavailableInUserRegion: productsUnavailableInUserRegion,
            bundleConfig: bundleConfig,
            preferredPatternGender: presetPreferredPatternGender,
            diaperSizeRationale: presetDiaperSizeRationale,
            trainingPantSizeRationale: presetTrainingPantSizeRationale,
            patternStepHeader: presetPatternStepHeader,
            sizeStepHeader: presetSizeStepHeader,
            initialized: true,
        });
        // For state properties that get set by setter functions, we call those setter functions here.
        if (wantsWipes !== undefined)
            changeWantsWipes(wantsWipes);
        if (presetSizes) {
            var state = get();
            changeSelectedSizes(presetSizes, state.wantsWipes);
        }
    },
}); };
/**
 * We save the bundle store in the module scope so that it can be accessed by whoever needs it, but we don't run create as a side effect on import
 * because this file ends up getting imported into theme-app.js, which means that it would be a side effect on every page of the website.
 */
var bundleStore;
function getBundleStore() {
    if (bundleStore)
        return bundleStore;
    bundleStore = {
        useBundleStore: (0, zustand_1.create)(bundleStoreInitializer),
    };
    return bundleStore;
}
exports.getBundleStore = getBundleStore;
function isDiaperSize(value) {
    return diaperSizes.includes(value);
}
exports.isDiaperSize = isDiaperSize;
function isTrainingSize(value) {
    return trainingSizes.includes(value);
}
exports.isTrainingSize = isTrainingSize;
